import { createContext, PropsWithChildren, useCallback, useContext } from 'react';
import { CustomSession } from '../session/type';
import axios from 'axios';

interface CleverAuthContextType {
    authorize: (code: string) => Promise<CustomSession>;
}

const CleverAuthContext = createContext<CleverAuthContextType | undefined>(undefined);

export const CleverAuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const authorize = useCallback(async (code: string): Promise<CustomSession> => {
        const response = await axios<{ id: string; email: string; name: string; role: string; sessionToken: string }>({
            method: 'post',
            url: `${import.meta.env.VITE_API_SERVICE_URL}/oauth/clever`,
            data: {
                code: code,
                redirect: window.location.origin + window.location.pathname,
            },
        });

        const data = response.data;
        return { token: data.sessionToken, user: { id: data.id, email: data.email, name: data.name, role: data.role } };
    }, []);

    return (
        <CleverAuthContext.Provider
            value={{
                authorize,
            }}
        >
            {children}
        </CleverAuthContext.Provider>
    );
};

export const useCleverAuth = (): CleverAuthContextType => {
    const context = useContext(CleverAuthContext);
    if (!context) {
        throw new Error('useCleverAuth must be used within an CleverAuthProvider');
    }

    return context;
};
